import coreService from "@/services/core";
import CipherService from "@/services/cipher";

import ProductService from "@/services/product";

import campaignService from "@/services/campaign";
import rewardService from "@/services/reward";
import moment from "moment-timezone";
import router from "@/router";
var _ = require("lodash");
export default {
  namespaced: true,
  state: {
    step: "step-1",
    groups: [],
    filed_product: [
      "code",
      "title_th",
      "seu_code",
      "productcg_code",
      "cost",
      "price"
    ],
    data_freeitems: [],
    data_freeitems1: [],
    rewardList: [],
    // data_freeitems:[
    //   {
    //     code : '',
    //     title_th : '',
    //     seu_code : '',
    //     productcg_code : '',
    //     cost : '',
    //     price : ''
    //   }
    // ],
    subgroups: [],
    cggroups: [],
    customers: [],
    products: [],
    default_set: {
      name: "",
      conditions: [{ "type": "Point" }],
      rewards: [],
      rewardset: [],
      badge: {
        title: "",
        image: ""
      },
      customers: [],
      // freeitems: [],
      rank: {
        purchase: [],
        product: [],
        payment: []
      },
      point: null
    },
    selectedProbrowse: [],
    probrowse: [],
    probrowseImport: [],
    probrowseImportTemp : [],
    selectListTemp : [],
    value: {
      type: "draft",
      campaign_code: null,
      campaign_title: null,
      campaign_detail: null,
      startdate: null,
      enddate: null,
      products: [],
      campaign_active: true,
      campaign_status: null,
      sets: [
        {
          name: "",
          conditions: [{ "type": "Point" }],
          rewards: [],
          rewardset: [],
          badge: {
            title: "",
            image: ""
          },
          customers: [],
          // freeitems: [],
          rank: {
            purchase: [],
            product: [],
            payment: []
          },
          point: null
        }
      ]
    },
    file_image: [],
    alertshow: false,
    alertcontent: null,
    unitmaster: [],
    customer_groups: [],
    importProduct: [],
    checkBoxes: [],
    selectProduct: [],
    searched: []
  },
  mutations: {
    setCampaign(state, value){
      state.value = value;
    },
    setStep(state, step) {
      state.step = step;
    },
    setType(state, value) {
      state.value.type = value;
    },
    setPromotionType(state, value) {
      state.value.promotion_type = value;
    },
    update(state, data) {
      const field = data.field;
      if(field == "campaign_code"){
        state.value[field] = data.value;
      }else{
        state.value[field] = data.value;
      }
      // console.log(state.value[field])
    },
    setGroups(state, value) {
      state.groups = value;
    },
    setSubgroups(state, value) {
      state.subgroups = value;
    },
    setCGgroups(state, value) {
      state.cggroups = value;
    },
    setUnitMaster(state, value) {
      state.unitmaster = value;
    },
    setProductBrowse(state, value) {
      state.probrowse = value;
    },
    replaceProductBrowse(state, value) {
      state.probrowse = []
      state.probrowse = value;
    },
    setProductsMaster(state, value) {
      state.value.products = value;
    },
    setValueSets(state, value) {
      state.value.sets = value;
    },
    setValuePoint(state, value) {
      state.value.sets[value.index].point = value.value;
    },
    setValueTabName(state, name) {
      state.value.sets[name.index].name = name.name;

    },
    setValueBadge(state, value) {
      state.value.sets[value.index].badge.title = value.value;
    },
    setValueConditions(state, value) {
      state.value.sets[value.index].conditions = value.conditions;
    },
    setValueRewardset(state, value) {
      state.value.sets[value.index].rewardset = value.rewards;
    },
    setValueoptions(state, value) {
      state.value.sets[value.index].options = value.options;
    },
    setRewards(state, data) {
      let index = data.index
      delete data.index
      state.value.sets[index].rewards.push(data);
    },
    setValueDataArr(state, dataArr) {
      // console.log("setValueDataArr->",dataArr)
      state.value.sets[dataArr.index].dataArr = dataArr.dataArr;
    },
    setFileImage(state, tempImage) {
      state.value.sets[tempImage.index].badge.image = tempImage.file;
    },
    setValueRank(state, value) {
      state.value.sets[value.index].rank.purchase = value.value[0];
      state.value.sets[value.index].rank.product = value.value[1];
      state.value.sets[value.index].rank.payment = value.value[2];
      // console.log("setValueRank",state.value.sets[value.index])
    },
    setValuePromotions(state, value) {
      state.value.sets[value.index].promotions = value.promotions;
    },
    setValueCustomers(state, value) {
      state.value.sets[value.index].customers = value.customers;
    },
    setSetStatus(state, value) {
      state.value.sets[value.index].status = value.status;
    },
    setFormatDate(state, value) {
      state.value[value.field] = value.value;
    },
    clearCampaignCreate(state) {
      state.value = {
        type: "draft",
        campaign_code: null,
        campaign_title: null,
        campaign_detail: null,
        startdate: null,
        enddate: null,
        campaign_active: true,
        products: [],
        sets: [state.default_set]
      };
    },
    setCustomerGroups(state, value) {
      state.customer_groups = value;
    },
    setValueFreeItems(state, value) {
      state.value.sets[value.i].freeitems.push(value.data[0]);
    },
    data_freeitems(state, value) {
      // console.log("setFreeItems")
      //state.data_freeitems[value.i] = value.result
      //console.log("state.data_freeitems", state.data_freeitems)
    },
    data_freeitems1(state, value) {
      // state.data_freeitems1 = [value.result]
      // state.data_freeitems1.push(value.result)arr.insert(2, 'C');

      if (state.data_freeitems[value.x] == undefined) {
        state.data_freeitems[value.x] = [];
      }
      state.data_freeitems[value.x][value.i] = value.result;
    },
    setAlertShow(state, value) {
      state.alertshow = value.value;
    },
    setRewardList(state, value) {
      state.rewardList = value;
    },
    setImportProduct(state, data) {
      state.probrowseImport.push(data);
    },
    setTempToprobrowseImport(state, data){
      state.probrowseImport = data.slice();
    },
    setCheckBoxes(state, data) {
      state.checkBoxes = data;
      //console.log("checkboxes",state.checkBoxes)
    },
    setRewardset(state, data) {
      let index = data.index
      state.value.sets[index].rewardset.push(data);
    },
    removeImportProduct(state, code) {
      for(let a=0;a<state.importProduct.length;a++){
        if(state.importProduct[a].code==code){
          state.importProduct.splice(a, 1);
        }
      }
    },
    removeSelectProduct(state, code) {
      // remove from import
      for(let i=0; i<state.probrowseImport.length; i++){
        if(state.probrowseImport[i].code == code){
          state.probrowseImport.splice(i, 1);
        }
      }

      // remove from selected
      for(let i=0; i<state.selectedProbrowse.length; i++){
        if(state.selectedProbrowse[i] == code){
          state.selectedProbrowse.splice(i, 1);
        }
      }
      
    },
    addAllCheckBoxes(state, length) {
      state.checkBoxes=[]
      for(let a=0;a<length;a++){
        state.checkBoxes.push(true);
      }
    },
    removeAllCheckBoxes(state) {
        state.checkBoxes = []
    },
    setCheckBoxesByIndex(state,index) {
      state.checkBoxes[index] = false
    },
    addFirstCheckBoxes(state) {
      state.checkBoxes.push(true);
    },
    setSelectProduct(state, data) {
      // console.log("setSelectProduct")
      // for(let a=0;a<data.length;a++){
      //   if(state.selectProduct.length < state.importProduct.length){
      //     state.selectProduct.push(data[a]);
      //   }
      // }
    },
    updateSelectedProbrowse(state, value){
      state.selectedProbrowse = value.slice();
      console.log("updateSelectedProbrowse",state.selectedProbrowse)
    },
    setSelectListTemp(state,value){
      state.selectListTemp.push(value);
    },
    clearImportProduct(state){
      state.probrowseImport = [];
    },
    clearRewards(state,index){
      state.value.sets[index].rewards = []
    },
    setSearched(state,value){
      state.searched = value
    },
    clearProduct(state,index){
      state.value["products"] = []
    },
  },
  actions: {
    getProductsMaster({ commit, dispatch, state }, productsData) {
      // console.log("getProductsMaster")
      if (productsData.productCode) {
        coreService
          .getProductsMaster(productsData.productCode)
          .then(response => {
            console.log(response)
            const products = state.value.products;
            var mapped = _.map(
              response,
              _.partialRight(_.pick, [
                "code",
                "title_th",
                "seu_code",
                "cost",
                "price"
              ])
            );
            _.forEach(mapped, value => {
              products.push(value);
            });
            commit("setProductsMaster", products);
            // const imports = state.probrowseImport;
            // var mapped2 = _.map(
            //   response,
            //   _.partialRight(_.pick, [
            //     "code",
            //     "productcg_code",
            //     "title_th",
            //     "seu_code",
            //     "cost",
            //     "price"
            //   ])
            // );
            // _.forEach(mapped2, value => {
            //   imports.push(value);
            // });
            // const selects = state.selectedProbrowse
            // var mapped3 = _.map(
            //   response,
            //   _.partialRight(_.pick, [
            //     "code"
            //   ])
            // );
            // _.forEach(mapped3, value => {
            //   selects.push(value.code);
            // });
            // console.log(selects)
            setTimeout(() => {
              dispatch("updateNetPrice");
            }, 500);
          })
          .catch(error => console.log(error));
      } else {
        commit("setProductsMaster", []);
      }
    },
    getProductBrowse({ commit }, productsData) {
      coreService
        .getProductBrowse(productsData)
        .then(response => {
          //console.log('response',response);
          commit("setProductBrowse", response);
        })
        .catch(error => console.log(error));
    },
    getProductBrowseUnlimit({ commit }, productsData) {
      coreService
        .getProductBrowseUnlimit(productsData)
        .then(response => {
          //console.log('response',response);
          commit("setProductBrowse", response);
        })
        .catch(error => console.log(error));
    },
    getUnitMaster({ commit }) {
      ProductService
        .getUnitMaster()
        .then(response => {
          let res = response;

          const data = [];
          for (const x in res) {
            data[res[x].code] = res[x].title;
          }
          console.log(data)
          commit("setUnitMaster", data);
        })
        .catch(error => console.log(error));
    },
    getGroups({ commit }) {
      coreService
        .getGroups()
        .then(response => {
          commit("setGroups", response);
        })
        .catch(error => console.log(error));
    },
    getSubgroups({ commit }, groupsMode) {
      if (groupsMode.parentCode) {
        coreService
          .getSubgroups(groupsMode.parentCode)
          .then(response => {
            commit("setSubgroups", response);
          })
          .catch(error => console.log(error));
      } else {
        commit("setSubgroups", []);
      }
    },
    getCGgroups({ commit }, subgroupsMode) {
      if (subgroupsMode.parentCode) {
        coreService
          .getSubgroups(subgroupsMode.parentCode)
          .then(response => {
            commit("setCGgroups", response);
          })
          .catch(error => console.log(error));
      } else {
        commit("setCGgroups", []);
      }
    },
    insertSet({ commit, state }, index) {
      let sets = state.value.sets;
      if (!sets[index]) {
        sets.push({
          name: "",
          conditions: [{ "type": "Point" }],
          rewards: [],
          rewardset: [],
          badge: {
            title: "",
            image: ""
          },
          customers: [],
          freeitems: [],
          rank: {
            purchase: [],
            payment: []
          },
          point: null
        });
      } else {
        // sets.push(sets[index]);
        sets.push(JSON.parse(JSON.stringify(sets[index])))
      }
      commit("setValueSets", sets);
    },
    resetSet({ commit, state }, index) {
      // console.log(index)
      const sets = state.value.sets;
      if (sets[index]) {
        sets[index] = state.default_set;
        commit("setValueSets", sets);
      }
    },
    deleteSet({ commit, state }, index) {
      const sets = state.value.sets;
      if (sets[index]) {
        sets.splice(index, 1);
        commit("setValueSets", sets);
      }
    },
    insertCondition({ commit, state }, { index, type }) {
      const conditions = state.value.sets[index].conditions;
      conditions.push({
        type
      });
      commit("setValueConditions", { index, conditions });
    },
    deleteCondition({ commit, state }, { index, index_condition }) {
      const conditions = state.value.sets[index].conditions;
      if (conditions[index_condition]) {
        conditions.splice(index_condition, 1);
        commit("setValueConditions", { index, conditions });
      }
    },
    insertReward({ commit, state }, { index, type }) {
      const rewards = state.value.sets[index].rewards;
      rewards.push({
        type
      });
      commit("setValueRewards", { index, rewards });
    },
    deleteRewardset({ commit, state }, { index, index_condition }) {
      const rewards = state.value.sets[index].rewardset;
      if (rewards[index_condition]) {
        rewards.splice(index_condition, 1);
        commit("setValueRewardset", { index, rewards });
      }
    },
    insertoptions({ commit, state }, { index, type }) {
      const options = state.value.sets[index].options;
      options.push({
        type
      });
      commit("setValueoptions", { index, options });
    },
    deleteOptions({ commit, state }, { index, index_condition }) {
      const options = state.value.sets[index].options;
      if (options[index_condition]) {
        options.splice(index_condition, 1);
        commit("setValueoptions", { index, options });
      }
    },
    insertData({ commit, state }, { index, dataArr, text }) {
      let value = null;
      if (text == "Point") {
        value = Number(dataArr.point);
        commit("setValuePoint", { index, value });
      }
      if (text == "badge") {
        value = dataArr.badge;
        commit("setValueBadge", { index, value });
      }
    },
    deleteData({ commit, state }, { index, index_condition, text }) {
      let formData = [];
      if (text === "Point") {
        // formData = state.value.sets[index].conditions;
      const conditions = state.value.sets[index].conditions;
      if (conditions[index_condition]) {
        conditions.splice(index_condition, 1);
        commit("setValueConditions", { index, conditions });
      }
        // formData = null;
        commit("setValueConditions", { index, conditions });
      }
      if (text === "badge") {
        formData = state.value.sets[index].badge.title;
        if (formData[index]) {
          formData.splice(index, 1);
          commit("setValueBadge", { index, formData });
        }
      }
    },
    insertFileImage({ commit, state }, { index, tempImage }) {
      // console.log(tempImage)
      let file = tempImage;
      commit("setFileImage", { index, file });
    },
    removeFileImage({ commit, state }, { index }) {
      let file = [];
      commit("setFileImage", { index, file });
    },
    insertRank({ commit, state }, { index, rankdata }) {
      let value = rankdata;
      // console.log("insertRank",value)
      commit("setValueRank", { index, value });
    },
    checkCodeFreeItem({ commit, state }, { code, index, setIndex }) {
      // console.log("checkCodeFreeItem",setIndex,index)
      coreService
        .getProductsMaster(code.split(","))
        .then(response => {
          if (response.length > 0) {
            // console.log("response",response)
            var data = _.map(
              response,
              _.partialRight(_.pick, state.filed_product)
            );
            // console.log("mapped",mapped)
            // const result = _.unionBy(state.value.sets[setIndex].freeitems[index], mapped, "code")
            // console.log("state",state.value.sets[setIndex].freeitems[index])
            // console.log("result",result)
            commit("setValueFreeItems", { x: setIndex, i: index, data: data });
            // commit('data_freeitems', { x: setIndex, i: index, result })
            //console.log("result",result)
            //commit('data_freeitems', { x: setIndex, i: index, data : mapped })
          } else {
            commit("setAlertShow", { value: true });
            state.alertcontent = "Please recheck your code";
          }
        })
        .catch(error => console.log(error));
    },
    insertPromotion({ commit, state }, { index, type }) {
      const promotions = state.value.sets[index].promotions;
      let vclass = null;
      let products = null;
      if (type === "Discount" || type === "Point") vclass = "mktops-step3-flex";
      else if (type === "Net Price") {
        vclass = "mktops-display-flex";
        products = _.map(
          state.value.products,
          _.partialRight(_.pick, [
            "code",
            "title_th",
            "seu_code",
            "cost",
            "price"
          ])
        );
      }
      promotions.push({
        type,
        vclass,
        products
      });
      commit("setValuePromotions", { index, promotions });
    },
    deletePromotion({ commit, state }, { index, index_promotion }) {
      const promotions = state.value.sets[index].promotions;
      if (promotions[index_promotion]) {
        promotions.splice(index_promotion, 1);
        commit("setValuePromotions", { index, promotions });
      }
    },
    insertTabName({ commit, state }, { index, name }) {
      commit("setValueTabName", { index, name });
    },
    insertCustomer({ commit, state }, { index, customer }) {
      // console.log("insertCustomer->",customer)
      const customers = state.value.sets[index].customers;
      let check = false;
      for (const x in customers) {
        if (customers[x]._id == customer._id) {
          check = true;
          break;
        }
      }
      if (!check) {
        customers.push(customer);
        // console.log("customers->",customers)
        commit("setValueCustomers", { index, customers });
      }
    },
    deleteCustomer({ commit, state }, { index, index_customer }) {
      const customers = state.value.sets[index].customers;
      if (customers[index_customer]) {
        customers.splice(index_customer, 1);
        commit("setValueCustomers", { index, customers });
      }
    },
    updateNetPrice({ commit, state }) {
      const products = state.value.products;
      _.forEach(state.value.sets, (set, x) => {
        _.forEach(set.promotions, (pm, i) => {
          if (pm.type === "Net Price" && pm.products != null) {
            const result = _.unionBy(pm.products, products, "code");
            commit("setValuePromotionProducts", { x, i, result });
          }
        });
      });
    },
    setFormatDate({ commit, state }) {
      const startdate = moment(new Date(state.value.startdate));
      const enddate = moment(new Date(state.value.enddate));
      commit("setFormatDate", {
        field: "startdate",
        value: startdate.format("YYYY-MM-DD")
      });
      commit("setFormatDate", {
        field: "enddate",
        value: enddate.format("YYYY-MM-DD")
      });
    },
    createCampaignToServer({ commit, state }) {
      const campaign = state.value;
      // console.log(typeof campaign.sets[0].point)
      campaign.file_image = state.file_image;
      //console.log("createCampaignToServer->",campaign)
      // _.forEach(campaign.sets, (set,x) => {
      //   _.forEach(set.campaign, (pm,i) => {
      //     if(pm.type === 'Points' || pm.type === 'Discount'){
      //       delete campaign.sets[x].campaign[i]['vclass']
      //       delete campaign.sets[x].campaign[i]['products']
      //     }else{
      //       delete campaign.sets[x].campaign[i]['vclass']
      //       delete campaign.sets[x].campaign[i]['value']
      //     }
      //   });
      // })
      for (let count = 0; count < campaign.sets.length; count++) {
      // //   // campaign.sets[count].conditions = []
      // //   // campaign.sets[count].rewards = []
        campaign.sets[count].conditions = []
        campaign.sets[count].rewardset = []
      }
      campaignService
        .createCampaign(campaign)
        .then(() => {
          commit("clearCampaignCreate");
          router.replace("/campaign/manage");
        })
        .catch(error => console.log(error));
    },
    getCustomerGroups({ commit }) {
      campaignService
        .getCustomerGroups()
        .then(response => {
          commit("setCustomerGroups", response);
        })
        .catch(error => console.log(error));
    },
    getRewardsList({ commit }) {
      rewardService
        .getAllReward()
        .then(response => {
          commit("setRewardList", response);
        })
        .catch(error => console.log(error));
    },
    insertRewards({ commit, state }, data) {
      commit("setRewards", data);
    },
    addImportProduct({ commit, state }, data) {

      commit("setImportProduct", data);
      //commit("setSelectProduct", data);
    },
    clearRewards({ commit, state }, index){
      commit("clearRewards",index);
    },
    clearImportProduct({ commit, state }) {
      commit("clearImportProduct");
    },
    addTempToprobrowseImport({ commit, state }, data) {
      commit("setTempToprobrowseImport", data);
    },
    replaceProductBrowse({ commit, state }, data) {
      commit("replaceProductBrowse", data);
    },
    removeProbrowseImport({ commit, state }, code) {
      // if(code instanceof Array){
      //   const dataProbrowseImport = []
      //   dataProbrowseImport.push(state.probrowseImport)
      //   console.log("dataProbrowseImport",dataProbrowseImport)
      //   for(let i=0; i<code.length; i++){
      //       console.log(i,dataProbrowseImport[0][i].code,code[i])
      //       if(dataProbrowseImport[0][i].code == code[i]){
      //         state.probrowseImport.splice(i, 1);
      //       }
      //   }
      // }else{
        for(let i=0; i<state.probrowseImport.length; i++){
          if(state.probrowseImport[i].code == code){
            state.probrowseImport.splice(i, 1);
          }
          if(state.probrowse[i].code == code){
            state.probrowse.splice(i, 1);
          }
        }
      // }
    },
    addCheckBoxes({ commit, state }, data) {
      commit("setCheckBoxes", data);
    },
    insertRewardset({ commit, state }, data) {
      commit("setRewardset", data);
    },
    selectAllProduct({ commit, state }, value){
      //console.log('selectall', state.probrowse);
      for(let i=0; i < state.probrowse.length; i++){
        var index = state.selectedProbrowse.indexOf(state.probrowse[i].code);
        if(index == -1)
        {
          state.selectedProbrowse.push(state.probrowse[i].code);
          state.probrowseImport.push(state.probrowse[i]);
          state.selectListTemp.push(state.probrowse[i])
        }
          
      }
    },
    unSelectAllProduct({ commit, state }, value){
      for(let i=0; i<state.probrowse.length; i++){
        for(let j=0; j < state.probrowseImport.length; j++)
        {
          if(state.probrowseImport[j].code == state.probrowse[i].code){
            state.probrowseImport.splice(j, 1);
          }
        }

      }

      for(let i=0; i < state.probrowse.length; i++){
          var index = state.selectedProbrowse.indexOf(state.probrowse[i].code);
          state.selectedProbrowse.splice(index, 1);
      }
    },
    addSelectListTemp({ commit, state },value){
      commit("setSelectListTemp", value);
    },
    updateSelectedProbrowse({ commit, state },value){
      commit("updateSelectedProbrowse", value);
    },
    setSearched({ commit, state},value){
      commit("setSearched", value);
    }
  },
  getters: {
    step: state => {
      return state.step;
    },
    groups: state => {
      return state.groups;
    },
    subgroups: state => {
      return state.subgroups;
    },
    cggroups: state => {
      return state.cggroups;
    },
    unitmaster: state => {
      return state.unitmaster;
    },
    sets: state => {
      return state.value.sets;
    },
    probrowse: state => {
      return state.probrowse;
    },
    stepper: state => {
      return state.stepper;
    },
    value: state => {
      return state.value;
    },
    customer_groups: state => {
      return state.customer_groups;
    },
    data_freeitems: state => {
      // console.log("getter",state.data_freeitems)
      return state.data_freeitems;
    },
    alertshow: state => {
      return state.alertshow;
    },
    data_freeitems1: state => {
      // console.log("getter",state.data_freeitems)
      return state.data_freeitems1;
    },
    alertcontent: state => {
      return state.alertcontent;
    },
    rewardList: state => {
      return state.rewardList;
    },
    importProduct: state => {
      return state.importProduct;
    },
    selectProduct: state => {
      return state.selectProduct;
    },
    checkBoxes: state => {
      return state.checkBoxes;
    },
    probrowseImport: state =>{
      return state.probrowseImport;
    },
    selectedProbrowse: state =>{
      return state.selectedProbrowse;
    },
    probrowseImportTemp: state =>{
      return state.probrowseImportTemp;
    },
    selectListTemp: state =>{
      return state.selectListTemp;
    },
    searched: state =>{
      return state.searched;
    }
  }
};
